import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, Redirect, Route, RouteProps } from 'react-router';
import { RoutePath } from './RoutePath';
import { StoreState } from '../store';

//#region Props & State
interface AuthenticatedStateProps {
    readonly isAuthenticated: boolean;
}
interface AuthenticatedDispatchProps { }
interface AuthenticatedProps extends AuthenticatedStateProps, AuthenticatedDispatchProps {
    readonly component: React.ComponentClass<any> | React.StatelessComponent<any>; // tslint:disable-line
    readonly [rest: string]: any // tslint:disable-line
}
interface AuthenticatedState { }
//#endregion

class AuthenticatedRoute extends React.Component<AuthenticatedProps, AuthenticatedState> {

    render() {
        const { isAuthenticated, component, ...rest } = this.props;
        const Component = component;
        // tslint:disable-next-line
        const render = (renderProps: RouteComponentProps<any>) => {
            let element = (
                <Redirect
                    to={{
                        pathname: RoutePath.Login,
                        state: { from: renderProps.location }
                    }}
                />
            );

            if (isAuthenticated) {
                element = <Component {...renderProps} />;
            }

            return element;
        };

        return <Route {...rest} render={render} />;
    }
}

//#region Connect
const mapStateToProps = (state: StoreState): AuthenticatedStateProps => ({
    isAuthenticated: state.auth != null
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({});

export default connect<AuthenticatedStateProps, AuthenticatedDispatchProps, RouteProps>(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute);
//#endregion



// WEBPACK FOOTER //
// ./src/routes/AuthenticatedRoute.tsx